{
  "verified": "확인됨",
  "iv_status": {
    "verified": "확인됨",
    "pending": "보류 중",
    "attention": "주의"
  },
  "zoom_in": "줌인",
  "zoom_out": "줌아웃",
  "rotate": "회전",
  "close": "닫기",
  "esc_to_close": "닫으려면 ESC를 누릅니다.",
  "play": "플레이",
  "pause": "일시 중지",
  "mute": "음소거",
  "unmute": "음소거 해제",
  "enter_full_screen": "전체 화면으로 들어가기",
  "exit_full_screen": "전체 화면 종료",
  "video_not_supported": "브라우저가 동영상 태그를 지원하지 않습니다.",
  "skip_forward": "앞으로 건너뛰기",
  "skip_backward": "뒤로 건너뛰기",
  "loading": "로드 중",
  "loading_video": "동영상 로드 중...",
  "loading_data_description": "데이터를 로드하는 동안 잠시 기다려주세요. 오래 걸리지 않을 것입니다.",
  "no_results": "결과 없음",
  "nothing_found": "찾을 수 없음",
  "save_changes": "변경 사항 저장",
  "saved_exclamation": "저장되었습니다!",
  "saving": "저장",
  "validating": "유효성 검사",
  "error": "오류",
  "optional": "선택 사항",
  "search_property": "부동산 검색",
  "reset_search": "검색 초기화",
  "no_items_to_show": "표시할 항목이 없습니다.",
  "showing_range_of_total_items": "장소 홀더_0__ 항목 중 {{total}} 항목 표시하기",
  "rows_per_page": "페이지당 행 수",
  "page_of_pages": "플레이스홀더_1__의 {{page}} 페이지",
  "go_to_first_page": "첫 페이지로 이동",
  "go_to_previous_page": "이전 페이지로 이동",
  "go_to_next_page": "다음 페이지로 이동",
  "go_to_last_page": "마지막 페이지로 이동",
  "sort_in_asc": "오름차순으로 정렬",
  "sort_in_desc": "내림차순으로 정렬",
  "sort_a_z": "정렬 A → Z",
  "sort_z_a": "정렬 Z → A",
  "clear_sorting": "정렬 지우기",
  "reach_us_at_email": "지원팀에 문의(support@chekin.com)",
  "please_wait": "잠시만 기다려주세요.",
  "feature_coming_soon": "곧 출시 예정",
  "feature_coming_soon_description": "이 기능은 현재 개발 중이며 곧 제공될 예정입니다. 업데이트를 기대해주세요!",
  "download_all": "모두 다운로드",
  "entry_forms": "참가 양식",
  "tutorial": "튜토리얼",
  "liveness_video": "생생한 동영상",
  "beta": "베타",
  "reviews": "리뷰",
  "learn_more": "자세히 알아보기",
  "this_cannot_be_reverted": "되돌릴 수 없습니다.",
  "delete": "삭제",
  "cancel": "취소",
  "you_have_made_changes": "변경한 사항이 있습니다.",
  "would_you_like_to_save_them": "저장하시겠습니까?",
  "save": "저장",
  "dont_save": "저장하지 않음",
  "copied_exclamation": "복사 완료!",
  "search_placeholder": "검색...",
  "type_to_search": "검색할 내용을 입력하세요...",
  "loading_more": "로드 중...",
  "no_options": "옵션 없음",
  "select_option": "옵션 선택",
  "clear_all": "모두 지우기",
  "remove_item": "플레이스홀더_0__ 제거하기",
  "upload_file": "파일 업로드",
  "download_attachment": "첨부 파일 다운로드",
  "remove_file": "파일 제거",
  "open_calendar": "캘린더 열기",
  "clear_dates": "날짜 지우기",
  "select_dates": "날짜 선택",
  "pick_date_range": "날짜 범위 선택",
  "from": "에서",
  "to": "To",
  "pick_month": "월 선택",
  "pick_date": "날짜 선택",
  "month": "월",
  "day": "일",
  "year": "연도",
  "done": "완료",
  "wrong_period_of_dates": "선택한 기간이 유효하지 않습니다.",
  "date_range_max_days_error_one": "범위는 {{count}}일을 초과할 수 없습니다.",
  "date_range_max_days_error_other": "범위는 {{count}}일을 초과할 수 없습니다.",
  "date_range_min_days_error_one": "범위는 {{count}}일 이상이어야 합니다.",
  "date_range_min_days_error_other": "범위는 {{count}}일 이상이어야 합니다.",
  "past_dates": "날짜는 {{minDate}} 이전일 수 없습니다.",
  "future_dates": "날짜는 {{maxDate}} 이후일 수 없습니다.",
  "signature_placeholder_text": "이 상자 안에 서명합니다.<br/> 손가락을 사용합니다.<br/> 시작하려면 탭합니다.",
  "open_devices_camera": "기기의 카메라 열기",
  "place_document_inside_frame": "프레임 안에 문서 배치",
  "close_other_application_that_may_be_using_your_camera": "카메라를 사용할 수 있는 다른 애플리케이션을 닫습니다.",
  "if_you_use_external_camera_disconnect_and_reconnect": "외부 카메라를 사용하는 경우 연결을 끊었다가 다시 연결하세요.",
  "close_the_browser_re_open_it": "브라우저를 닫았다가 다시 열기",
  "camera_errors": {
    "experiencing_camera_issues": "카메라 문제가 발생했나요?",
    "chekin_cant_use_your_camera": "Chekin이 카메라를 사용할 수 없습니다.",
    "please_try_a_different_browser": "이 브라우저에서는 카메라가 작동하지 않습니다. 다른 브라우저에서 링크를 열어 보세요.",
    "permissions_denied": "권한 거부됨",
    "camera_permissions_denied": "카메라가 열리지 않나요? 브라우저에서 카메라 사용 권한을 허용했는지 확인하세요.",
    "no_camera_device_found": "카메라 장치를 찾을 수 없습니다. 카메라를 연결하세요.",
    "constraints_camera_error": "사용 가능한 디바이스로는 제약 조건을 충족할 수 없습니다.",
    "safari_camera_error": "Safari에서 카메라 요구 사항을 충족할 수 없음",
    "try_chrome_or_firefox": "크롬 또는 파이어폭스를 사용해 보세요."
  },
  "clear": "지우기",
  "show_less": "덜 보기",
  "show_more": "자세히 보기",
  "tap_here_to_sign": "서명하려면 여기를 탭하세요.",
  "click_here_to_sign": "서명하려면 여기를 클릭하세요.",
  "prefix": "접두사",
  "prefix_required": "접두사 필수",
  "reset": "초기화",
  "show_password": "비밀번호 표시",
  "hide_password": "비밀번호 숨기기",
  "increment": "증분",
  "decrement": "감소",
  "create_option": "\"{{input}}\" 만들기",
  "year_out_of_range": "연도는 {{min}}에서 {{max}} 사이여야 합니다.",
  "clear_date": "날짜 지우기",
  "select_date": "날짜 선택",
  "draw_signature_here": "여기에 서명을 해 주세요",
  "signature_hint": "마우스나 손가락을 사용하세요",
  "clear_signature": "서명 지우기",
  "draw_signature_here_mobile": "서명을 그려주세요",
  "signature_hint_mobile": "손가락을 사용하세요",
  "camera_access_needed": "카메라 접근 권한 필요",
  "camera_access_needed_text": "사진을 찍으려면 카메라 사용을 허용해 주세요. 카메라 사용이 차단된 경우, 브라우저 설정에서 카메라 사용을 허용한 후 다시 시도해 주세요.",
  "dialog": "대화"
}
